import React from 'react';
import {StyledComponent} from 'styled-components';
import {OrbitTheme} from './orbit-theme.interface';
import {OrbitComponent} from '../../components/base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';

/**
 * @deprecated
 */
export function styledByDevice<C extends keyof JSX.IntrinsicElements | React.ComponentType<any>, O extends object = {}>(
    pc: StyledComponent<C, OrbitTheme, O>, mobile: StyledComponent<C, OrbitTheme, O>
): StyledComponent<C, OrbitTheme, O> {

    let ComponentDefinition = observer(class extends OrbitComponent<any>{
        render() {
            let Component = null;

            if(this.services.device.isMobile) {
                Component = mobile;
            } else {
                Component = pc;
            }

            return (
                <Component ref={this.props.forwardedRef} {...this.props}>
                    {this.props.children}
                </Component>
            );
        }
    });


    let finalComponent = React.forwardRef((props, ref) => <ComponentDefinition {...props} forwardedRef={ref}/>);

    return (finalComponent as any) as StyledComponent<C, OrbitTheme, O>;
}